import { useSubscriptionDetailsQuery } from "../../../../../api/chartSmart/useSubscriptionDetailsQuery";
import { CHARTSMART_PLAN } from "../../../../../consts/ChartSmart";

const onAdaptCurrency = (price) => {
  return price / 100;
};

export const usePrices = () => {
  const { data } = useSubscriptionDetailsQuery();

  const prices = {
    [CHARTSMART_PLAN.payg]:
      onAdaptCurrency(data?.chartSmartPlans?.payg?.price) || 0,
    [CHARTSMART_PLAN.starter]:
      onAdaptCurrency(data?.chartSmartPlans?.starter?.price) || 0,
    [CHARTSMART_PLAN.pro]:
      onAdaptCurrency(data?.chartSmartPlans?.pro?.price) || 0,
    [CHARTSMART_PLAN.unlimited]:
      onAdaptCurrency(data?.chartSmartPlans?.unlimited?.price) || 0,
  };

  const limits = {
    [CHARTSMART_PLAN.payg]: data?.chartSmartPlans?.payg?.limit || 0,
    [CHARTSMART_PLAN.starter]: data?.chartSmartPlans?.starter?.limit || 0,
    [CHARTSMART_PLAN.pro]: data?.chartSmartPlans?.pro?.limit || 0,
    [CHARTSMART_PLAN.unlimited]: data?.chartSmartPlans?.unlimited?.limit || 0,
  };

  return {
    getPrice: (plan) => prices[plan] || 0,
    getLimit: (plan) => limits[plan] || 0,
  };
};
